<div class="managers-rows">
  @for (managerReport of managerReports(); track $index) {
    <div
      class="row"
      [class.not-assigned]="!isAssignedManager()"
    >
      @if (isAssignedManager()) {
        <button
          appDeleteFocus
          class="delete-button"
          (click)="handleDeleteManagerButtonClick(managerReport.id, monthData().monthNumber)"
        >
          <i class="delete-icon"></i>
        </button>
      }
      <div class="column name">{{ managerReport.manager.name }}</div>
      <div class="column">
        <app-update-input-number
          [startValue]="managerReport['plan']"
          [rolesWhichCanEdit]="['ROLE_ADMIN', 'ROLE_REVIEWER']"
          [onlyReadonlyField]="!isAssignedManager()"
          (saveValue)="handleUpdateValue({
            managerId: managerReport.id,
            property:'plan',
            value: $event,
            month: monthData().monthNumber,
            currentProduct: product()
          })"
        />
      </div>
      <div class="column">
        <app-fact-value
          [factValue]="formatNumberValue(managerReport['fact'])"
          [published]="formatNumberValue(managerReport['releasedFact'])"
          [expected]="formatNumberValue(managerReport['waitingFact'])"
        />
      </div>
      <div class="column"> {{ formatNumberValue(managerReport['realization']) }}% </div>
      <div
        class="column actions"
        [class.collapsed-column]="!product().platforms.product.isActionsColumnOpen"
      >
        @if (product().platforms.product.isActionsColumnOpen) {
          <app-grouped-value-columns
            [columns]="[
              formatNumberValue(managerReport['views']),
              formatNumberValue(managerReport['clicks']),
              formatNumberValue(managerReport['visits']),
              formatNumberValue(managerReport['orders']),
              formatNumberValue(managerReport['requests'])
            ]"
            [widths]="actionsWidths"
          />
        }
      </div>
      <div
        class="column stats"
        [class.collapsed-column]="!product().platforms.product.isStatsColumnOpen"
      >
        @if (product().platforms.product.isStatsColumnOpen) {
          <app-grouped-value-columns
            [columns]="[
              formatNumberValue(managerReport['cpv'], 2), formatNumberValue(managerReport['cpc'], 2),
              formatNumberValue(managerReport['cpa'], 2),
              formatNumberValue(managerReport['cps'], 2),
              formatNumberValue(managerReport['cpz'], 2)
            ]"
            [widths]="statsWidths"
          />
        }

      </div>
      <div
        class="column results"
        [class.collapsed-column]="!product().platforms.product.isResultsColumnOpen"
      >
        @if (product().platforms.product.isResultsColumnOpen) {
          <app-grouped-value-columns
            [columns]="[
              formatNumberValue(team().reviewerReport['averageCheck']),
              (managerReport['integrationsPlan'] ?? 0) + '/' + (managerReport['integrationsFact'] ?? 0)
            ]"
            [widths]="resultsWidths"
            [isIntegrationsPlan]="true"
            [isAssignedManager]="isAssignedManager()"
            (updateIntegrationsPlan)="handleUpdateValue({
              managerId: managerReport.id,
              property:'integrationsPlan',
              value: $event,
              month: monthData().monthNumber,
              currentProduct: product()
            })"
          />
        }
      </div>
    </div>
  }
  @if (isAssignedManager()) {
    @if (getUnAddedManagers(team()).length) {
      <button
        class="add-manager-button round-button"
        (click)="toggleUnUnAddedManagersList(team())"
      >
        {{ team().isUnAddedManagersListOpen ? '-' : '+' }}
      </button>
    }
  }
  @if (team().isUnAddedManagersListOpen) {
    <div
      #managersList
      class="un-added-managers-list"
      [forbidTrigger]="!team().isUnAddedManagersListOpen"
      [excludeClass]="'add-manager-button'"
      (appClickOutside)="closeUnAddedManagersList(team())"
      (keydown)="handleKeyDown($event, team())"
      tabindex="0"
    >
      @if (isAssignedManager()) {
        @for (manager of getUnAddedManagers(team()); track $index) {
          <div class="un-added-manager">
            <div
              class="manager-name"
              [class.selected]="selectedManagerIndex === $index"
              (click)="addManagerToManagerReports(monthData().monthNumber, team().id, +manager.id)"
            >
              {{ manager.name }}
            </div>
          </div>
        }
      }
    </div>
  }
</div>
